"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../../java/lang/IllegalArgumentException"));

var _ItemVisitor = _interopRequireDefault(require("../../index/ItemVisitor"));

var _PointOnGeometryLocator = _interopRequireDefault(require("./PointOnGeometryLocator"));

var _LinearRing = _interopRequireDefault(require("../../geom/LinearRing"));

var _SortedPackedIntervalRTree = _interopRequireDefault(require("../../index/intervalrtree/SortedPackedIntervalRTree"));

var _LineSegment = _interopRequireDefault(require("../../geom/LineSegment"));

var _Polygonal = _interopRequireDefault(require("../../geom/Polygonal"));

var _LinearComponentExtracter = _interopRequireDefault(require("../../geom/util/LinearComponentExtracter"));

var _ArrayListVisitor = _interopRequireDefault(require("../../index/ArrayListVisitor"));

var _RayCrossingCounter = _interopRequireDefault(require("../RayCrossingCounter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var IndexedPointInAreaLocator =
/*#__PURE__*/
function () {
  function IndexedPointInAreaLocator() {
    _classCallCheck(this, IndexedPointInAreaLocator);

    IndexedPointInAreaLocator.constructor_.apply(this, arguments);
  }

  _createClass(IndexedPointInAreaLocator, [{
    key: "locate",
    value: function locate(p) {
      var rcc = new _RayCrossingCounter.default(p);
      var visitor = new SegmentVisitor(rcc);

      this._index.query(p.y, p.y, visitor);

      return rcc.getLocation();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IndexedPointInAreaLocator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_PointOnGeometryLocator.default];
    }
  }]);

  return IndexedPointInAreaLocator;
}();

exports.default = IndexedPointInAreaLocator;

var SegmentVisitor =
/*#__PURE__*/
function () {
  function SegmentVisitor() {
    _classCallCheck(this, SegmentVisitor);

    SegmentVisitor.constructor_.apply(this, arguments);
  }

  _createClass(SegmentVisitor, [{
    key: "visitItem",
    value: function visitItem(item) {
      var seg = item;

      this._counter.countSegment(seg.getCoordinate(0), seg.getCoordinate(1));
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SegmentVisitor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_ItemVisitor.default];
    }
  }]);

  return SegmentVisitor;
}();

SegmentVisitor.constructor_ = function () {
  this._counter = null;
  var counter = arguments[0];
  this._counter = counter;
};

var IntervalIndexedGeometry =
/*#__PURE__*/
function () {
  function IntervalIndexedGeometry() {
    _classCallCheck(this, IntervalIndexedGeometry);

    IntervalIndexedGeometry.constructor_.apply(this, arguments);
  }

  _createClass(IntervalIndexedGeometry, [{
    key: "init",
    value: function init(geom) {
      var lines = _LinearComponentExtracter.default.getLines(geom);

      for (var i = lines.iterator(); i.hasNext();) {
        var line = i.next();
        var pts = line.getCoordinates();
        this.addLine(pts);
      }
    }
  }, {
    key: "addLine",
    value: function addLine(pts) {
      for (var i = 1; i < pts.length; i++) {
        var seg = new _LineSegment.default(pts[i - 1], pts[i]);
        var min = Math.min(seg.p0.y, seg.p1.y);
        var max = Math.max(seg.p0.y, seg.p1.y);

        this._index.insert(min, max, seg);
      }
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 2) {
        var min = arguments[0],
            max = arguments[1];
        var visitor = new _ArrayListVisitor.default();

        this._index.query(min, max, visitor);

        return visitor.getItems();
      } else if (arguments.length === 3) {
        var _min = arguments[0],
            _max = arguments[1],
            _visitor = arguments[2];

        this._index.query(_min, _max, _visitor);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IntervalIndexedGeometry;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return IntervalIndexedGeometry;
}();

IntervalIndexedGeometry.constructor_ = function () {
  this._index = new _SortedPackedIntervalRTree.default();
  var geom = arguments[0];
  this.init(geom);
};

IndexedPointInAreaLocator.SegmentVisitor = SegmentVisitor;
IndexedPointInAreaLocator.IntervalIndexedGeometry = IntervalIndexedGeometry;

IndexedPointInAreaLocator.constructor_ = function () {
  this._index = null;
  var g = arguments[0];
  if (!((0, _hasInterface.default)(g, _Polygonal.default) || g instanceof _LinearRing.default)) throw new _IllegalArgumentException.default("Argument must be Polygonal or LinearRing");
  this._index = new IntervalIndexedGeometry(g);
};